import type { SharedData } from '../../types';
import { createContext, useContext, type ReactNode } from 'react';
import { Footer } from './Footer';
import { Navbar } from './Navbar';
import { StickyCta } from './StickyCta';
import { CookieConsent } from './CookieConsent';
import { t } from '../../i18n/t';

const SharedContext = createContext<SharedData | null>(null);

export function useShared(): SharedData {
  const value = useContext(SharedContext);
  if (!value) {
    throw new Error('useShared must be used within <Layout>');
  }
  return value;
}

export interface LayoutProps {
  children: ReactNode;
  shared: SharedData;
  showStickyCta?: boolean;
}

export function Layout({ children, shared, showStickyCta = true }: LayoutProps) {
  return (
    <SharedContext.Provider value={shared}>
      <div className="flex min-h-screen flex-col bg-white">
        <a href="#main" className="skip-link">
          {t('ui.skip_to_content')}
        </a>

        <Navbar />

        <main id="main" className={showStickyCta ? 'flex-1 pb-20 lg:pb-0' : 'flex-1'}>
          {children}
        </main>

        <Footer />

        {showStickyCta && <StickyCta />}
        <CookieConsent />
      </div>
    </SharedContext.Provider>
  );
}
